import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import { useParams } from 'react-router-dom'
import SupplyOrderView from './view/SupplyOrderView'

const SupplyOrder = () => {

    const { supplyOrderId } = useParams()

    // console.log('supplyOrderId', supplyOrderId)

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Заявка на постачання № ' + supplyOrderId}
            isBack={true}
            // options={
            //     <SupplyOrderOptions />
            // }
        />
		<MyBlock>
			<SupplyOrderView 
				supplyOrderId={supplyOrderId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default SupplyOrder